"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProjections = calculateProjections;
var dates_1 = __importDefault(require("./dates"));
/**
 * Calculate projected values based on current velocity
 */
function calculateProjections(activitySummaries, totals, taxYear, taxYearStartMonth, rebatePercentage) {
    var startYear = taxYear.split('-')[0];
    var _a = (0, dates_1.default)(startYear, taxYearStartMonth.toString()), startDate = _a.startDate, endDate = _a.endDate;
    var now = new Date();
    var isCurrentYear = now >= startDate && now <= endDate;
    if (!isCurrentYear) {
        return { isCurrentYear: false };
    }
    var msPerDay = 1000 * 60 * 60 * 24;
    var daysElapsed = Math.floor((now.getTime() - startDate.getTime()) / msPerDay);
    var totalDays = Math.floor((endDate.getTime() - startDate.getTime()) / msPerDay);
    // If no days have elapsed, can't calculate projection
    if (daysElapsed === 0) {
        return {
            isCurrentYear: true,
            daysElapsed: 0,
            totalDays: totalDays,
        };
    }
    var projectionMultiplier = totalDays / daysElapsed;
    var projectedActivities = activitySummaries.map(function (activity) { return (__assign(__assign({}, activity), { expenses: activity.expenses * projectionMultiplier, wages: activity.wages * projectionMultiplier, super: activity.super * projectionMultiplier, assets: activity.assets * projectionMultiplier, equipment: activity.equipment * projectionMultiplier, total: activity.total * projectionMultiplier })); });
    var projectedTotalExpenses = totals.totalExpenses * projectionMultiplier;
    var projectedTotalWages = totals.totalWages * projectionMultiplier;
    var projectedTotalSuper = totals.totalSuper * projectionMultiplier;
    var projectedTotalAssets = totals.totalAssets * projectionMultiplier;
    var projectedTotalEquipment = totals.totalEquipment * projectionMultiplier;
    var projectedGrandTotal = totals.grandTotal * projectionMultiplier;
    var projectedTotalTaxOffset = projectedGrandTotal * rebatePercentage;
    return {
        isCurrentYear: true,
        daysElapsed: daysElapsed,
        totalDays: totalDays,
        projectedTotalExpenses: projectedTotalExpenses,
        projectedTotalWages: projectedTotalWages,
        projectedTotalSuper: projectedTotalSuper,
        projectedTotalAssets: projectedTotalAssets,
        projectedTotalEquipment: projectedTotalEquipment,
        projectedGrandTotal: projectedGrandTotal,
        projectedTotalTaxOffset: projectedTotalTaxOffset,
        projectedActivities: projectedActivities,
    };
}
